function Tier(data) {

    var self = this;

    if (typeof (data) === "undefined" || data === null) {
        return null;
    }

    // Observables
    self.description = data.description;
    self.isTrial = data.isTrial;
    self.trialLength = data.trialLength;
    self.trialDateStart = data.dateTrialStarted;
    self.trialDateExpire = data.dateTrialExpires;
    self.maxComputers = ko.observable(data.maxComputers);
    self.isManualEventsRefreshing = data.isManualEventsRefreshing;
    self.isCCleanerAnalysis = data.isCCleanerAnalysis;
    self.isCCleanerClean = data.isCCleanerClean;
    self.isCCleanerRegistryFix = data.isCCleanerRegistryFix;
    self.isCCleanerRegistryScan = data.isCCleanerRegistryScan;
    self.isChartsAutoStart = data.isChartsAutoStart;
    self.isCharting = data.isCharting;
    self.isPairedInstallers = data.isPairedInstallers;
    self.isScheduling = data.isScheduling;
    self.isTabbedHomepage = data.isTabbedHomepage;
    self.maxGroupCount = data.maxGroupCount;
    self.isTwoFactorAuth = data.isTwoFactorAuth;
    self.eventHistoryPeriodInDays = data.eventHistoryPeriodInDays;
    self.gridViewEnabled = data.gridViewEnabled;
    self.gridViewSearchEnabled = data.gridViewSearchEnabled;
    self.defaultComputersView = data.defaultComputersView;
    self.userCanDiscount = data.userCanDiscount;
    self.reportingEnabled = data.reportingEnabled;
    self.isDropboxIntegration = data.isDropboxIntegration;
    self.isNetworkTools = data.isNetworkTools;
    self.isShutdown = data.isShutdown;
    self.isProcesses = data.isProcesses;
    self.isInstalledSoftware = data.isInstalledSoftware;
    self.isDefragglerAnalysis = data.isDefragglerAnalysis;
    self.isDefragglerDefrag = data.isDefragglerDefrag;
    self.isWindowsUpdates = data.isWindowsUpdates;
    self.isAddSoftware = data.isAddSoftware;

    // Public Functions
    self.isBusinessTier = function() {
        return self.description.indexOf("Business") > -1;
    };

    self.isProTier = function() {
        return self.description.indexOf("Pro") > -1;
    };

    return self;
}